import * as React from 'react';
import { ISearchResult } from '../../state-helpers/search-results';
import { IEpiProps } from '../../state-helpers/epi-props';
import { Lock } from './lock';

interface IProps {
    result: ISearchResult;
    epiProps: IEpiProps;

    onClick: () => void;
}

export class SearchResultMember extends React.Component<IProps, any> {

    placeholderImg(e) {
        e.target.src = '../../../Static/imgs/aap-img-placeholder.png';
    };

    render() {
        var result = this.props.result;
        return (
            <div className="search-result-wrapper">
                <a className="search-result search-result-member" href={this.props.result.url} onClick={this.props.onClick}>

                    <div className="search-result-header">
                        <div className="search-result-title" dangerouslySetInnerHTML={{ __html: this.props.result.title + ' ' + this.props.result.designation }}></div>                     
                        {this.props.result.isFaap && <div className="search-result-badge">{this.faapBadgeText}</div>}
                    </div>
                    {((result.subSpecialties && result.subSpecialties.length > 0) || (result.medicalSpecialties && result.medicalSpecialties.length > 0)) &&
                        <div className="search-result-header">
                            <div className="search-result-title board-cert">{this.allSpecialties}</div>
                        </div>
                    }
                    <div className="search-result-member">
                        {result.address && result.address.length > 0 &&
                            <div className="search-result-meta">
                                <span className="search-result-meta-publication" dangerouslySetInnerHTML={{ __html: this.props.result.address }}></span>
                            </div>
                        }
                        {result.phoneNumber && result.phoneNumber.length > 0 &&
                            <div className="search-result-meta">
                                <span className="search-result-meta-publication" dangerouslySetInnerHTML={{ __html: this.props.result.phoneNumber }}></span>
                            </div>
                        }
                        {result.email && result.email.length > 0 &&
                            <div className="search-result-link email-link">
                                <u>{result.email}</u>
                            </div>
                        }
                        {result.practiceUrl && result.practiceUrl.length > 0 &&
                            <div className="search-result-meta">
                                <span className="search-result-meta-publication" dangerouslySetInnerHTML={{ __html: this.props.result.practiceUrl }}></span>
                            </div>
                        }
                        <div className="search-result-link">
                            <Lock url={this.props.result.url} />
                            <u>
                                {this.props.result.friendlyUrl}
                            </u>
                        </div>
                    </div>

                    {/* <div className="search-result-shop-img">
                        <img onError={this.placeholderImg.bind(this)} src={this.props.result.imageUrl} />
                    </div>*/}
                </a>
            </div>
        )
    }

    get boardCertifications() {
        return this.props.result.boardCertificationNames && this.props.result.boardCertificationNames.join(', ');
    }

    get subSpecialties() {
        return this.props.result.subSpecialties && this.props.result.subSpecialties.map(x => `${x} (ABP)`);
    }

    get medicalSpecialties() {
        if (this.props.result.medicalSpecialties) {
            return this.props.result.medicalSpecialties.map(x => `${x} (ABMS)`);
        }
        else {
            return null;
        }
    }

    get allSpecialties() {
        return [...this.subSpecialties || [], ...this.medicalSpecialties || []].join(', ');
    }

    get faapBadgeText() {
        const faapText = "FAAP";
        return this.props.epiProps.faapText ? this.props.epiProps.faapText.toUpperCase() : faapText;
    }

}